import { Routes } from '@angular/router';
import { patientsResolver } from './patients.resolver';
import { patientsRecordResolver } from './patients-record/patients-record.resolver';
import { patObsResolver } from './patient-observation/pat-obs.resolver';
// import { PatientWrapperComponent } from './patient-wrapper/patient-wrapper.component';
import { patCondResolver } from './patient-condition/pat-cond.resolver';
import { NotFoundComponentComponent } from './not-found-component/not-found-component.component';
import { MedicationComponent } from './medication/medication.component';
import { medicationResolver } from './medication/medication.resolver';
import { appointmentResolver } from './appointment.resolver';
import { encounterResolver } from './encounter/encounter.resolver';
import { appAuthGuard } from './shared/auth/app-auth.guard';
import { roleGuard } from './shared/auth/role.guard';


import { labRequestsResolver } from './lab-requests/lab-requests.resolver';
import { medReqResResolver } from './medicine-requests/med-req-res.resolver';
// import { PatientRegistrationComponent } from './patient-registration/patient-registration.component';
import { patRegResolver } from './patient-reg/pat-reg.resolver';
import { SpecimenComponent } from './specimen/specimen_old.component';
import { DetailsCardzComponent } from './details-cardz/details-cardz.component';
// import { BookingsFormComponent } from './bookings-form/bookings-form.component';
// import { AddObservationComponent } from './patient-observation/add-observation/add-observation.component';
import { patientRegistrationCenterResolver } from './patient-registration-center/patient-registration-center.resolver';
import { PatientRegistrationApprovedComponent } from './patient-registration-center/patient-registration-approved.component';
import { PatientRegistrationDeceasedComponent } from './patient-registration-center/patient-registration-deceased.component';
import { appWrapperDataResolver } from './app-wrapper/app-wrapper-data.resolver';
// import { AddChargesComponent } from './charges/add-charges/add-charges.component';
// import { SupplyStockComponent } from './supply-stock/supply-stock.component';
//import { ServiceDetailsComponent } from './service-details/service-details.component';




import { defaultPasswordGuard } from './shared/auth/default-password.guard';
// import { SupplyStockComponent } from './supply-stock/supply-stock.component';

export const routes: Routes = [
    {
    path: '',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
    data: {
      title: 'Home',
      breadCrumbTitle: 'Home',
      breadCrumbIcon: 'home'
    }
  },
  {
  path: 'e-learning',
  loadComponent: () =>
    import('./e-learning/e-learning.component').then(m => m.ELearningComponent)
},
  {
    path: 'about',
    loadComponent: () => import('./aboutUs/about.component').then(m => m.AboutComponent),
    data: {
      title: 'About Us',
      breadCrumbTitle: 'About Us',
      breadCrumbIcon: 'info'
    }
  },
  {
    path: 'contact',
    loadComponent: () => import('./contactUs/contact.component').then(m => m.ContactComponent),
    data: {
      title: 'Contact Us',
      breadCrumbTitle: 'Contact Us',
      breadCrumbIcon: 'mail'
    }
  },
    {
        path: 'home',
        loadComponent: () => import('./home/home.component').then(m => m.HomeComponent)
    },
    {
        path: 'events',
        loadComponent: () => import('./events/events.component').then(m => m.EventsComponent)
    },
    {
    path: 'events/:eventId/register',
    loadComponent: () => import('./events/event-registration-page.component').then(m => m.EventRegistrationPageComponent)
    },
    {
        path: 'hospital-selection',
        loadComponent: () => import('./hospital-selection-login/hospital-selection-login.component').then(m => m.HospitalSelectionLoginComponent)
    },
    {
        path: 'register-hospital',
        loadComponent: () => import('./hospital-registration/hospital-registration.component').then(m => m.HospitalRegistrationComponent) // You'll need to create this
    },
    {
        path: 'practitioners/:id',
        loadComponent: () => import('./practitioner-details/practitioner-details.component').then(m => m.PractitionerDetailsComponent),
        data: {
            title: 'Practitioner Details',
            breadCrumbTitle: 'Practitioner Details',
            breadCrumbIcon: 'badge',
            roles: ['hospitaladmin', 'healthcareadmin']
        }
    },

    {
        path: 'unauthorized',
        loadComponent: () => import('./unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent),
        data: {
            title: 'Access Denied',
            breadCrumbTitle: 'Unauthorized',
            breadCrumbIcon: 'block'
        }
    },
    {
        path: 'reset-password',
        loadComponent: () => import('./reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
    },
    {
        path: "testing",
        loadComponent: () => import('./testing/testing.component').then(m => m.TestingComponent),
        children: [
            {
                path: "encounter",
                loadComponent: () => import('./encounter-check/encounter-check.component').then(m => m.EncounterCheckComponent)
            },
            {
                path: "add-obs",
                loadComponent: () => import('./patient-observation/add-observation/add-observation.component').then(m => m.AddObservationComponent)
            },
            {
                path: "check-sheet",
                loadComponent: () => import('./check-sheet/check-sheet.component').then(m => m.CheckSheetComponent)
            },
            //admission'
            {
                path: "document",
                loadComponent: () => import('./document/document.component').then(m => m.DocumentComponent)
            },
            {
                path: "calendar",
                loadComponent: () => import('./calendar/calendar.component').then(m => m.CalendarComponent),
            },
            {
                path: "dosage-validator",
                loadComponent: () => import('./testing/medication-dosage-validator/medication-dosage-validator.component').then(m => m.MedicationDosageValidatorComponent),
                data: {
                    title: 'Medication Dosage Validator',
                    breadCrumbTitle: 'Dosage Validator',
                    breadCrumbIcon: 'vaccines'
                }
            },
            {

                path: "ai-chat",
                loadComponent: () => import('./aichat/aichat.component').then(m => m.AichatComponent)
            },
            {
                path: "details",
                loadComponent: () => import('./cardz-details-check/cardz-details-check.component').then(m => m.CardzDetailsCheckComponent)

            },
            {
                path: "book-try",
                loadComponent: () => import('./bookings-form/bookings-form.component').then(m => m.BookingsFormComponent)
            },


            {
                path: "schedule",
                loadComponent: () => import('./create-schedule/create-schedule.component').then(m => m.CreateScheduleComponent)
            },
            {
                path: "add-medicine",
                loadComponent: () => import('./medication2/add-medication/add-medication.component').then(m => m.AddMedicationComponent)
            },
            {
                path: "ec-bills",
                loadComponent: () => import('./encounter-v2/encounter-v2.component').then(m => m.EncounterV2Component)

            }, {
                path: "lab-report",
                loadComponent: () => import('./labreport/labreport.component').then(m => m.LabreportComponent)

            },
            {
                path: "add-report",
                loadComponent: () => import('./labreport/add-report/add-report.component').then(m => m.AddReportComponent)

            },
            {
                path: "medicine",
                loadComponent: () => import('./medication2/medication2.component').then(m => m.MedicationComponent2),

            },
            {
                path: "admission",
                loadComponent: () => import('./admission/admission.component').then(m => m.AdmissionComponent),
                data: { title: 'Admission' }
                // resolve: { admission: admissionResolver }
            },
            {
                path: "admission-analytics",
                loadComponent: () => import('./admission-analytics/admission-analytics.component').then(m => m.AdmissionAnalyticsComponent),

            },
            {
                path: "vitals",
                loadComponent: () => import('./patient-observation/add-vitals/add-vitals.component').then(m => m.AddVitalsComponent),
            },
            {
                path: "tasks",
                loadComponent: () => import('./testing-tasks/testing-tasks.component').then(m => m.TestingTasksComponent),


            },
            {

                path: "patientSide",
                loadComponent: () => import('./patient-sidedetails/patient-sidedetails.component').then(m => m.PatientSidedetailsComponent)
            },
            {
                path: "allergy",
                loadComponent: () => import('./allergy/allergy.component').then(m => m.AllergyComponent),
            },
            {
                path: "task-list",
                loadComponent: () => import('./tasks/tasks-table/tasks-table.component').then(m => m.TasksTableComponent),

            },
            {
                path: "tests-requests",
                loadComponent: () => import('./lab-requests/lab-requests.component').then(m => m.LabRequestsComponent),
                resolve: { labRequests: labRequestsResolver }


            },
            {
                path: "claims",
                loadComponent: () => import('./orders/orders.component').then(m => m.OrdersComponent),


            },
            {
                path: "invoice",
                loadComponent: () => import('./invoice/invoice.component').then(m => m.InvoiceComponent)
            },
            {
                path: "invoice/:patientId",
                loadComponent: () => import('./invoice/invoice.component').then(m => m.InvoiceComponent)
            },

            {
                path: "medicine-requests",
                loadComponent: () => import('./medicine-requests/medicine-requests.component').then(m => m.MedicineRequestsComponent),
                // resolve: { medReqRes: medReqResResolver }


            },
            {
                path: "specimen-details",
                loadComponent: () => import('./specimen/specimen-details/specimen-details.component').then(m => m.SpecimenDetailsComponent),
                data: {
                    title: "Specimen Details", breadCrumbTitle: "Specimen Details",
                    breadCrumbIcon: "biotech"
                },
            },
            {
                path: "org",
                loadComponent: () => import('./hospital-details/hospital-details.component').then(m => m.HospitalDetailsComponent),
                data: {
                    title: "Hospital Details", breadCrumbTitle: "Hospital Details",
                    breadCrumbIcon: "local_hospital"
                },
            },

            //services,
            {
                path: "org-services",
                loadComponent: () => import('./services/services.component').then(m => m.ServicesComponent),
                data: {
                    title: "Available Services", breadCrumbTitle: "Available Services",
                    breadCrumbIcon: "work"
                }
            }
        ]
    },
    {
        path: "app",
        loadComponent: () => import('./app-wrapper/app-wrapper.component').then(m => m.AppWrapperComponent),
        resolve: { orgWide: appWrapperDataResolver },
        canActivate: [appAuthGuard, roleGuard, defaultPasswordGuard],
        canActivateChild: [appAuthGuard, roleGuard],
        data: { title: 'Dashboard' },
        children: [
            //services-creation
            {
                path: "invoice/:patientId",
                loadComponent: () => import('./invoice/invoice.component').then(m => m.InvoiceComponent)
            },

            {
                path: 'services-details',
                loadComponent: () => import('./service-details/service-details.component').then(m => m.ServiceDetailsComponent),
                data: {
                    title: 'Service Details',
                    breadCrumbTitle: 'Service Details',
                    breadCrumbIcon: 'build',
                    roles: ['hospitaladmin', 'alliedhealthprofessional'],
                }
            },

            {
                path: 'add-service-details',
                loadComponent: () => import('./add-service-details/add-service-details-page.component').then(m => m.AddServiceDetailsPageComponent),
                data: {
                    title: 'Add Service Details',
                    breadCrumbTitle: 'Add Service Details',
                    breadCrumbIcon: 'add',
                    roles: ['hospitaladmin', 'alliedhealthprofessional'],
                }
            },
            {
                path: 'healthcare-services',
                loadComponent: () => import('./healthcare-services-v2/healthcare-services-v2.component').then(m => m.HealthcareServicesV2Component),
                data: {
                    title: 'Healthcare Services',
                    breadCrumbTitle: 'Healthcare Services',
                    breadCrumbIcon: 'medical_services',
                    roles: ['hospitaladmin']
                }
            },
            //service-reuest
            {
                path: 'service-requests',
                // loadComponent: () =>
                //     import('./service-requests/service-requests.component').then(m => m.ServiceRequestsComponent),
                loadComponent: () => import('./service-request-wrapper/service-request-wrapper.component').then(m => m.ServiceRequestWrapperComponent),
                data: {
                    title: 'Service Requests',
                    breadCrumbTitle: 'Service Requests',
                    breadCrumbIcon: 'assignment',
                },
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'lab-tests'
                    },
                    //lab
                    {
                        path: 'lab-tests',
                        loadComponent: () => import('./lab-requests/lab-requests.component').then(m => m.LabRequestsComponent),
                        resolve: { labRequests: labRequestsResolver }

                    },
                    {
                        path: ':type',
                        loadComponent: () => import('./service-requests/service-requests.component').then(m => m.ServiceRequestsComponent),
                        data: {
                            title: 'Service Requests',
                            breadCrumbTitle: 'Service Requests',
                            breadCrumbIcon: 'assignment',
                        }
                    }

                ]

            },
            //medicine-stock
            {
                path: 'practitioners',
                loadComponent: () => import('./practitioner-list/practitioner-list.component').then(m => m.PractitionerListComponent),
                data: {
                    title: 'Pending Practitioners',
                    breadCrumbTitle: 'Practitioners',
                    breadCrumbIcon: 'badge',

                }
            },
            {
                path: "practitioner-register",
                loadComponent: () => import('./practitioner-registration/practitioner-registration.component').then(m => m.PractitionerRegistrationComponent)
            },
            {
                path: 'organizations',
                loadComponent: () => import('./organization-management/organization-management.component').then(m => m.OrganizationManagementComponent),
                data: {
                    title: "Organizations Management", breadCrumbTitle: "Organizations Management",
                    breadCrumbIcon: "add_business"
                },
            },
            {
  path: 'global-remote-doctors',
  loadComponent: () =>
    import('./global-remote-doctors/global-remote-doctors.component')
      .then(m => m.GlobalRemoteDoctorsComponent),
  data: {
    title: 'Global Remote Doctors',
    breadCrumbTitle: 'Remote Doctors',
    breadCrumbIcon: 'medical_services',
    roles: ['superadmin']
  }
},

            {
                path: 'Users',
                loadComponent: () => import('./super-admin-management/superadmin-list.component').then(m => m.SuperadminListComponent),
                data: {
                    title: "Users Management", breadCrumbTitle: "Users Management",
                    breadCrumbIcon: "people"
                },
            },

            {
                path: 'superadmin/create',
                loadComponent: () => import('./super-admin-management/superadmin-create.component').then(m => m.SuperadminCreateComponent)
            },
            {
                path: "org-reg",
                loadComponent: () => import('./hospital-registration/hospital-registration.component').then(m => m.HospitalRegistrationComponent),
                data: {
                    title: "Hospital Registration", breadCrumbTitle: "Hospital Registration",
                    breadCrumbIcon: "add_business"
                },
            },
            {
                path: 'notifications',
                loadComponent: () => import('./notifications-page/notifications-page.component').then(m => m.NotificationsPageComponent),
                data: {
                    title: 'Notifications',
                    breadCrumbTitle: 'Notifications',
                    breadCrumbIcon: 'notifications'
                }
            },
            {
                path: 'messaging',
                loadComponent: () => import('./messaging/messaging-inbox-page.component').then(m => m.MessagingInboxPageComponent),
                data: {
                    title: 'Messaging Inbox',
                    breadCrumbTitle: 'Messaging',
                    breadCrumbIcon: 'forum'
                }
            },
            {
                path: 'messaging/thread',
                loadComponent: () => import('./messaging/messaging-thread-page.component').then(m => m.MessagingThreadPageComponent),
                data: {
                    title: 'Messaging Thread',
                    breadCrumbTitle: 'Thread',
                    breadCrumbIcon: 'chat'
                }
            },
            {
                path: "document",
                loadComponent: () => import('./document/document.component').then(m => m.DocumentComponent)
            },
            {
                path: "calendar",
                loadComponent: () => import('./calendar/calendar.component').then(m => m.CalendarComponent),
            },
            {
                path: "schedule",
                loadComponent: () => import('./create-schedule/create-schedule.component').then(m => m.CreateScheduleComponent)

            },
            {
                path: "schedules",
                 data: { title: 'Schedules' },
                children: [
                    {
                        path: "create",
                        loadComponent: () => import('./create-schedule/create-schedule.component').then(m => m.CreateScheduleComponent)

                    },
                    {
                        path: "admin-calendar/:practitionerId",
                        loadComponent: () => import('./schedules/admin-schedule-calendar/admin-schedule-calendar.component').then(m => m.AdminScheduleCalendarComponent)
                    },

                    {
                        path: 'schedules-list',
                        loadComponent: () => import('./schedules/schedules.component').then(m => m.SchedulesComponent),
                        canActivate: [appAuthGuard],
                        data: {
                            title: 'Schedules',
                            breadCrumbTitle: 'Schedules',
                            breadCrumbIcon: 'calendar_today',
                            roles: [
                                'remotedoctor',
                                'hospitaladmin',
                                'doctor',
                                'primaryhealthcareprovider',
                                'healthcareassistant',
                                'nursemidwife',
                                'alliedhealthprofessional'
                            ]
                        }
                    },
                    //default path
                    {
                        path: "",
                        redirectTo: 'schedules-list',
                        pathMatch: "full"



                    }

                ],
            },
            {
                path: "tasks",
                loadComponent: () => import('./tasks/tasks-table/tasks-table.component').then(m => m.TasksTableComponent),
    data: { title: 'Tasks' }
            },
            {
                path: "duty-roster",
                loadComponent: () => import('./duty-roster/duty-roster.component').then(m => m.DutyRosterComponent),
                canActivate: [appAuthGuard, roleGuard],
                data: {
                    title: 'Duty Roster',
                    breadCrumbTitle: 'Duty Roster',
                    breadCrumbIcon: 'calendar_month',
                    roles: ['healthcareadmin', 'hospitaladmin', 'remotedoctor', 'doctor']
                }
            },
            {
                path: "specimens",
                loadComponent: () => import('./specimens/specimens.component').then(m => m.SpecimensComponent),
            },
            {
                path: "lab-supplies",
                loadComponent: () => import('./lab-supply/lab-supply.component').then(m => m.LabSupplyComponent),
                data: { roles: ['hospitaladmin', 'alliedhealthprofessional', 'lab', 'labtechnician', 'pharmacist'] }
            },
            {
                path: "medicine-stock",
                loadComponent: () => import('./medication2/medication2.component').then(m => m.MedicationComponent2)
            },
            {
                path: "admission",
                loadComponent: () => import('./admission/admission.component').then(m => m.AdmissionComponent),
                // resolve: { admission: admissionResolver }
            },
            {
                path: "admission-location",
                loadComponent: () => import('./admission-location/admission-location.component').then(m => m.AdmissionLocationComponent)
            },
            {
                path: "admission-location/add",
                loadComponent: () => import('./admission-location/add-admission-location.component').then(m => m.AddAdmissionLocationComponent)
            },
            {
                path: "service-codes",
                loadComponent: () => import('./add-service-request-codes/service-request-codes-list.component').then(m => m.ServiceRequestCodesListComponent),
                data: {
                    title: "Service Request Codes",
                    breadCrumbTitle: "Service Codes",
                    breadCrumbIcon: "science",
                    roles: ['hospitaladmin', 'alliedhealthprofessional', 'lab', 'labtechnician']
                }
            },
            {
                path: "service-codes/add",
                loadComponent: () => import('./add-service-request-codes/add-service-request-codes.component').then(m => m.AddServiceRequestCodesComponent),
                data: {
                    title: "Add Service Code",
                    breadCrumbTitle: "Add Service Code",
                    breadCrumbIcon: "science",
                    roles: ['hospitaladmin', 'alliedhealthprofessional', 'lab', 'labtechnician']
                }
            },
            {
                path: "claims",
                loadComponent: () => import('./orders/orders.component').then(m => m.OrdersComponent),


            },
            {
                path: "patient-bills/:encounterId/:patientId",
                loadComponent: () => import('./encounter-v2/encounter-v2.component').then(m => m.EncounterV2Component),


            },

            {
                path: "invoice",
                loadComponent: () => import('./invoice/invoice.component').then(m => m.InvoiceComponent)
            },
            {
                path: "profile",
                loadComponent: () => import('./profile/profile.component').then(m => m.ProfileComponent),
                data: { title: 'Profile' }

            },
            {
                path: "org-services",
                loadComponent: () => import('./services/services.component').then(m => m.ServicesComponent),
                data: {
                    title: "Available Services", breadCrumbTitle: "Available Services",
                    breadCrumbIcon: "work"
                }
            },

            {
                path: "org",
                loadComponent: () => import('./hospital-details/hospital-details.component').then(m => m.HospitalDetailsComponent),
                data: {
                    title: "Hospital Details", breadCrumbTitle: "Hospital Details",
                    breadCrumbIcon: "local_hospital"
                }

            },
            {
                path: "company-settings",
                loadComponent: () => import('./company-settings/company-settings.component').then(m => m.CompanySettingsComponent),
                data: {
                    title: "Company Settings",
                    breadCrumbTitle: "Company Settings",
                    breadCrumbIcon: "settings",
                    roles: ['hospitaladmin', 'superadmin']
                }

            },
            {
                path: "dashboard",
                loadComponent: () => import('./dashboards-wrapper/dashboards-wrapper.component').then(m => m.DashboardsWrapperComponent),
                data: { title: 'Dashboard' },

            },
            {
  path: 'leaderboard',
  loadComponent: () =>
    import('./leaderboard/leaderboard.component').then(m => m.LeaderboardComponent),
  data: {
    title: 'Leaderboard',
    breadCrumbTitle: 'Leaderboard',
    breadCrumbIcon: 'leaderboard',
    roles: ['superadmin']
  }
},
            {
                path: 'terminology-migration',
                loadComponent: () => import('./admin-dashboard/terminology-migration/terminology-migration.component').then(m => m.TerminologyMigrationComponent),
                data: {
                    title: 'Terminology Sync',
                    breadCrumbTitle: 'Terminology Sync',
                    breadCrumbIcon: 'sync',
                    roles: ['superadmin']
                }
            },
              {
                path: 'eventmanager-dashboard',
                loadComponent: () => import('./eventmanager-dashboard/eventManager-dashboard.component').then(m => m.EventManagerDashboardComponent),
                data: {title: 'Event Manager Dashboard', roles: ['eventmanager'] }
            },
            {
    path: 'global-event-manager-dashboard',
    loadComponent: () =>
        import('./global-event-manager-dashboard/global-event-manager-dashboard.component')
            .then(m => m.GlobalEventManagerDashboardComponent),
    data: {
        title: 'Global Event Manager Dashboard',
        breadCrumbTitle: 'Event Dashboard',
        breadCrumbIcon:  'event',
        roles: ['globaleventmanager', 'superadmin']
    }
},
            {
                path: 'pharmacy-dashboard',
                loadComponent: () => import('./pharmacy-dashboard/pharmacy-dashboard.component').then(m => m.PharmacyDashboardComponent),
                data: {title: 'Pharmacy Dashboard', roles: ['pharmacist', 'pharmacy', 'hospitaladmin'] }
            },
            {
                path: 'receptionist-dashboard',
                loadComponent: () => import('./receptionist-dashboard/receptionist-dashboard.component').then(m => m.ReceptionistDashboardComponent),
                data: {  title: 'Healthcare Admin Dashboard', roles: ['healthcareadmin', 'cashier', 'hospitaladmin'] }
            },
            {
                path: 'profit-margins',
                loadComponent: () => import('./profit-margins/profit-margins.component').then(m => m.ProfitMarginsComponent),
                data: {
                    title: 'Profit Margins',
                    breadCrumbTitle: 'Profit Margins',
                    breadCrumbIcon: 'trending_up',
                    roles: ['cashier']
                }
            },
            {
                path: "patient-registration",
                loadComponent: () => import('./patient-registration-center/patient-registration-center.component').then(m => m.PatientRegistrationCenterComponent),
                resolve: { patientCenter: patientRegistrationCenterResolver },
                data: {
                    title: "Patient Registration", breadCrumbTitle: "Patient Registration",
                    breadCrumbIcon: "person_add"
                },
                children: [
                    { path: '', redirectTo: 'pending', pathMatch: 'full' },
                    { path: 'pending', loadComponent: () => import('./patient-reg/patient-reg.component').then(m => m.PatientRegComponent) },
                    { path: 'approved', loadComponent: () => import('./patient-reg/patient-reg.component').then(m => m.PatientRegComponent) },
                    { path: 'deceased', loadComponent: () => import('./patient-reg/patient-reg.component').then(m => m.PatientRegComponent) },
                    { path: 'archived', loadComponent: () => import('./patient-reg/patient-reg.component').then(m => m.PatientRegComponent) },
                    { path: 'import', loadComponent: () => import('./patient-registration-import/patient-registration-import.component').then(m => m.PatientRegistrationImportComponent) },
                ]
            },
            { path: "patient-registration-data", redirectTo: "patient-registration", pathMatch: 'full' },
            {
                path: "medicine-requests",
                loadComponent: () => import('./medicine-requests/medicine-requests.component').then(m => m.MedicineRequestsComponent),
                // resolve: {
                //     medReqRes: medReqResResolver
                // }
                // ,
    data: { title: 'Medicine Requests' }

            },

            {
                path: "appointments",
                loadComponent: () => import('./appointment/appointment.component').then(m => m.AppointmentComponent),
                resolve: { appointment: appointmentResolver }
                ,
    data: { title: 'Appointments' }

            },
            {
                path: "appointments/add",
                loadComponent: () => import('./make-appointments/make-appointments.component').then(m => m.MakeAppointmentsComponent)
            },
            {
                path: "book-appointment",
                loadComponent: () => import('./bookings-form/bookings-form.component').then(m => m.BookingsFormComponent),
                data: {
                    title: "Book Appointment",
                    breadCrumbTitle: "Book Appointment",
                    breadCrumbIcon: "event_available",
                    defaultBookingType: "Telemedicine"
                }
            },
{
    path: "remote-doctor/my-hospitals",
    loadComponent: () =>
        import('./remote-doctor/remote-doctor-dashboard/remote-doctor-dashboard.component')
            .then(m => m.RemoteDoctorDashboardComponent),
    data: {
        title: 'My Hospitals',
        breadCrumbTitle: 'My Hospitals',
        breadCrumbIcon: 'local_hospital',
        roles: ['remotedoctor']
    }
},{
    path: 'hospital-remote-doctors',
    loadComponent: () =>
        import('./remote-doctor/hospital-remote-doctors/hospital-remote-doctors.component')
            .then(m => m.HospitalRemoteDoctorsComponent),
    data: {
        title: 'Remote Doctors',
        breadCrumbTitle: 'Remote Doctors',
        breadCrumbIcon: 'medical_information',
        roles: ['hospitaladmin']
    }
},
            {
                path: "tests-requests",
                loadComponent: () => import('./lab-requests/lab-requests.component').then(m => m.LabRequestsComponent),
                resolve: { labRequests: labRequestsResolver }
            },
            {
                path: "observation-reference-ranges",
                loadComponent: () => import('./observation-reference-ranges/observation-reference-ranges.component').then(m => m.ObservationReferenceRangesComponent),
                data: {
                    title: "Observation Reference Ranges",
                    breadCrumbTitle: "Reference Ranges",
                    breadCrumbIcon: "analytics",
                    roles: ['lab', 'labtechnician', 'alliedhealthprofessional']
                }
            },

            {
                path: "medication-dispense",
                loadComponent: () => import('./medication-dispense/medication-dispense.component').then(m => m.MedicationDispenseComponent),
                data: {
                    title: "Medication Dispenses",
                    breadCrumbTitle: "Medication Dispenses",
                    breadCrumbIcon: "medical_services"
                }
            },
            {
                path: "diagnostic-reports",
                loadComponent: () => import('./diagnostic-report/diagnostic-report.component').then(m => m.DiagnosticReportComponent),
                data: {
                    title: "Diagnostic Reports",
                    breadCrumbTitle: "Diagnostic Reports",
                    breadCrumbIcon: "science"
                }
            },
            {
                path: 'triage',
                loadComponent: () => import('./triage/triage.component').then(m => m.TriageComponent),
                data: {
                    title: 'Triage',
                    breadCrumbTitle: 'Triage',
                    breadCrumbIcon: 'health_and_safety',
                }
            },
            {
                path: "patient-encounters",
                loadComponent: () => import('./patient-encounters/patient-encounters.component').then(m => m.PatientEncountersComponent),
                data: {
                    title: "Patient Encounters",
                    breadCrumbTitle: "Encounters",
                    breadCrumbIcon: "local_hospital"
                }
            },
            {
                path: "charges",
                loadComponent: () => import('./charges/charges.component').then(m => m.ChargesComponent),
                data: {
                    title: "Charges",
                    breadCrumbTitle: "Charges",
                    breadCrumbIcon: "payments"
                }
            },
            {
                path: "charges/add",
                loadComponent: () => import('./charges/add-charges/add-charges.component').then(m => m.AddChargesComponent),
                data: {
                    title: "Add Charge",
                    breadCrumbTitle: "Add Charge",
                    breadCrumbIcon: "add_circle"
                }
            },
            {
                path: "supply-stock",
                // component: SupplyStockComponent,
                 loadComponent: () => import('./supply-stock/supply-stock.component').then(m => m.SupplyStockComponent),
                data: {
                    title: "Supply Stock",
                    breadCrumbTitle: "Supply Stock",
                    breadCrumbIcon: "inventory_2",
                    roles: ['hospitaladmin', 'lab']
                }
            },

            {
                loadComponent: () => import('./patients/patients.component').then(m => m.PatientsComponent),
                path: "patients",
                resolve: { patientsRegistrationData: patientsResolver },
                data: { title: 'Patients' }
            },
            {
                loadComponent: () => import('./admitted-patients/admitted-patients.component').then(m => m.AdmittedPatientsComponent),
                path: "admitted-patients",
                resolve: { patientsRegistrationData: patientsResolver }
                ,
                data: { title: 'Admitted Patients' }

            },
            {
                path: "consultation-requests",
                loadComponent: () => import('./consultation-requests/consultation-requests.component').then(m => m.ConsultationRequestsComponent),
                data: {
                    title: "Consultation Requests",
                    breadCrumbTitle: "Consultations",
                    breadCrumbIcon: "assignment_ind"
                }
            },
            {
                path: "referral-requests",
                loadComponent: () => import('./referral-requests/referral-requests.component').then(m => m.ReferralsComponent),
                data: {
                    title: "Referral Requests",
                    breadCrumbTitle: "Referrals",
                    breadCrumbIcon: "forward_to_inbox"
                }
            },
            {
                path: "request-documents/:serviceRequestId",
                loadComponent: () => import('./referral-document-viewer/request-document-viewer-page.component').then(m => m.RequestDocumentViewerPageComponent),
                data: {
                    title: "Shared Clinical Document",
                    breadCrumbTitle: "Request Document",
                    breadCrumbIcon: "description"
                }
            },
            {
                path: "zoom-meetings",
                loadComponent: () => import('./zoom-meeting/zoom-meeting.component').then(m => m.ZoomMeetingComponent),
                data: {
                    title: "Zoom Meeting",
                    breadCrumbTitle: "Zoom Meeting",
                    breadCrumbIcon: "videocam"
                }
            },
            {
                path: "zoom-meetings/:appointmentId",
                loadComponent: () => import('./zoom-meeting/zoom-meeting.component').then(m => m.ZoomMeetingComponent),
                data: {
                    title: "Zoom Meeting",
                    breadCrumbTitle: "Zoom Meeting",
                    breadCrumbIcon: "videocam"
                }
            },
            {
                path: "admitted-patients/:id",
                loadComponent: () => import('./patient-admission-wrapper/patient-admission-wrapper.component').then(m => m.PatientAdmissionWrapperComponent),
                children: [
                    {
                        path: "tasks",
                        loadComponent: () => import('./tasks/tasks-table/tasks-table.component').then(m => m.TasksTableComponent),
                    },
                    {
                        path: "analytics",
                        loadComponent: () => import('./admission-analytics/admission-analytics.component').then(m => m.AdmissionAnalyticsComponent)
                    },
                    {
                        path: "",
                        redirectTo: "tasks",
                        pathMatch: 'full'
                    }
                ],
                // resolve: { admission: admissionResolver }

            },
            {

                path: "patients/:id",
                loadComponent: () => import('./patient-wrapper/patient-wrapper.component').then(m => m.PatientWrapperComponent),
                resolve: { patientData: patientsRecordResolver },
                 data: { title: 'Patient Record' },
                children: [
                    //service-requests
                    {
                        path: 'service-requests',
                        // loadComponent: () =>
                        //     import('./service-requests/service-requests.component').then(m => m.ServiceRequestsComponent),
                        loadComponent: () => import('./service-request-wrapper/service-request-wrapper.component').then(m => m.ServiceRequestWrapperComponent),
                        data: {
                            title: 'Service Requests',
                            breadCrumbTitle: 'Service Requests',
                            breadCrumbIcon: 'assignment',
                        },
                        children: [
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: 'lab-tests'
                            },
                            //lab
                            {
                                path: 'lab-tests',
                                loadComponent: () => import('./lab-requests/lab-requests.component').then(m => m.LabRequestsComponent),
                                resolve: { labRequests: labRequestsResolver }

                            },
                            {
                                path: ':type',
                                loadComponent: () => import('./service-requests/service-requests.component').then(m => m.ServiceRequestsComponent),
                                data: {
                                    title: 'Service Requests',
                                    breadCrumbTitle: 'Service Requests',
                                    breadCrumbIcon: 'assignment',
                                }
                            }

                        ]

                    },
                    //allergies
                    {
                        path: "tests-requests",
                        loadComponent: () => import('./lab-requests/lab-requests.component').then(m => m.LabRequestsComponent),
                        resolve: { labRequests: labRequestsResolver }


                    },

                    {
                        path: "allergies",
                        loadComponent: () => import('./allergy/allergy.component').then(m => m.AllergyComponent)

                    },
                    //immunizations
                    {
                        path: "immunizations",
                        loadComponent: () => import('./immunization/immunization.component').then(m => m.ImmunizationComponent)
                        ,
            data: { title: 'Immunizations' }

                    },


                    {
                        path: "patients-reg",
                        loadComponent: () => import('./patient-registration/patient-registration.component').then(m => m.PatientRegistrationComponent),
                        resolve: { patReg: patRegResolver }

                    },
                    {
                        path: "encounters",
                        resolve: { patientEncounter: encounterResolver },
                        loadComponent: () => import('./encounter/encounter.component').then(m => m.EncounterComponent),
                        data: {
                            title: "Patient Encounter"
                        }

                    },
                    {
                        path: "observations",
                        resolve: { patientObservations: patObsResolver },
                        loadComponent: () => import('./patient-observation/patient-observation.component').then(m => m.PatientObservationComponent),
                        data: { title: "Patient Observations" }
                    },
                    {
                        path: "diagnosis",

                        loadComponent: () => import('./patient-condition/patient-condition.component').then(m => m.PatientConditionComponent),
                        resolve: { patCond: patCondResolver },
                        data: { title: "Patient Diagnosis" }

                    },
                    {
                        path: "tests-requests",
                        loadComponent: () => import('./lab-requests/lab-requests.component').then(m => m.LabRequestsComponent),
                        resolve: { labRequests: labRequestsResolver }


                    },
                    // {
                    //     path: "medications",

                    //     component: MedicationComponent,
                    //     resolve: { patMed: medicationResolver },
                    //     data: { title: "Patient Medications" }

                    // },
                    {
                        path: "medications",

                        loadComponent: () => import('./medicine-requests/medicine-requests.component').then(m => m.MedicineRequestsComponent),
                        // resolve: {
                        //     medReqRes: medReqResResolver
                        // },

                        data: { title: "Patient Medications" }

                    },
                    {
                        path: "diagnostic-reports",
                        loadComponent: () => import('./diagnostic-report/diagnostic-report.component').then(m => m.DiagnosticReportComponent),
                        data: {
                            title: "Diagnostic Reports",
                            breadCrumbTitle: "Diagnostic Reports",
                            breadCrumbIcon: "science"
                        }
                    },
                    {
                        path: "patient-encounters",
                        loadComponent: () => import('./patient-encounters/patient-encounters.component').then(m => m.PatientEncountersComponent),
                        data: {
                            title: "Encounters",
                            breadCrumbTitle: "Encounters",
                            breadCrumbIcon: "local_hospital"
                        }
                    },
                    {
                        path: "patient-documents",
                        loadComponent: () => import('./patient-documents/patient-documents.component').then(m => m.PatientDocumentsComponent),
                        data: {
                            title: "Patient Documents",
                            breadCrumbTitle: "Documents",
                            breadCrumbIcon: "folder"
                        }
                    },
                    {
                        path: "zoom-meeting",
                        loadComponent: () => import('./zoom-meeting/zoom-meeting.component').then(m => m.ZoomMeetingComponent),
                        data: {
                            title: "Zoom Meeting",
                            breadCrumbTitle: "Zoom Meeting",
                            breadCrumbIcon: "videocam"
                        }
                    },
                    {
                        path: "zoom-meeting/:appointmentId",
                        loadComponent: () => import('./zoom-meeting/zoom-meeting.component').then(m => m.ZoomMeetingComponent),
                        data: {
                            title: "Zoom Meeting",
                            breadCrumbTitle: "Zoom Meeting",
                            breadCrumbIcon: "videocam"
                        }
                    },
                     {
                        path: "zoom-meeting",
                        loadComponent: () => import('./zoom-meeting/zoom-meeting.component').then(m => m.ZoomMeetingComponent),
                        data: {
                            title: "Zoom Meeting",
                            breadCrumbTitle: "Zoom Meeting",
                            breadCrumbIcon: "videocam"
                        }
                    },
                    {
                        path: "request-documents/:serviceRequestId",
                        loadComponent: () => import('./referral-document-viewer/request-document-viewer-page.component').then(m => m.RequestDocumentViewerPageComponent),
                        data: {
                            title: "Shared Clinical Document",
                            breadCrumbTitle: "Request Document",
                            breadCrumbIcon: "description"
                        }
                    },


                    {
                        path: "summary",

                        loadComponent: () => import('./patients-record/patients-record.component').then(m => m.PatientsRecordComponent),
                        resolve: { patientData: patientsRecordResolver },
                        data: { title: "Patient Summary" }

                    },


                    {
                        path: "",
                        redirectTo: "summary",
                        pathMatch: 'full'

                    },
                    {
                        path: "**",
                        component: NotFoundComponentComponent
                    }

                ]

            },
            {
                path: "",
                redirectTo: "dashboard",
                pathMatch: 'full'
            }
        ]

    },

    {
        path: "DummyMedicationRequest",
        loadComponent: () => import('./dummy-medication-request-details/dummy-medication-request-details.component').then(m => m.DummyMedicationRequestDetailsComponent),

    },

    {
        path: "login",
        loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
       data: { title: "Login" }
    },

    {
        path: "auth/callback",
        loadComponent: () => import('./authcallack/authcallack.component').then(m => m.AuthcallackComponent),
        data: { title: "Login Redirect" }
    },

    {
        path: "launch",
        loadComponent: () => import('./launch/launch.component').then(m => m.LaunchComponent),
       data: { title: "Launch" }
    },

    {
        path: "patient-hospital-selection",
        loadComponent: () => import('./patient-hospital-selection/patient-hospital-selection.component').then(m => m.PatientHospitalSelectionComponent)
    },
    {
        path: "upload-demo",
        loadComponent: () => import('./upload-ui/azure-upload-demo.component').then(m => m.AzureUploadDemoComponent)
    },
    {
        path: 'testing',
        children: [
            {
                path: "encounter",
                loadComponent: () => import('./encounter-check/encounter-check.component').then(m => m.EncounterCheckComponent)
            },
            {
                path: "add-obs",
                loadComponent: () => import('./patient-observation/add-observation/add-observation.component').then(m => m.AddObservationComponent)
            },
            {
                path: "check-sheet",
                loadComponent: () => import('./check-sheet/check-sheet.component').then(m => m.CheckSheetComponent)
            },
            //admission'
            {
                path: "document",
                loadComponent: () => import('./document/document.component').then(m => m.DocumentComponent)
            },
            {
                path: "calendar",
                loadComponent: () => import('./calendar/calendar.component').then(m => m.CalendarComponent),
            },
            {

                path: "ai-chat",
                loadComponent: () => import('./aichat/aichat.component').then(m => m.AichatComponent)
            },
            {
                path: "details",
                loadComponent: () => import('./cardz-details-check/cardz-details-check.component').then(m => m.CardzDetailsCheckComponent)

            },
            {
                path: "book-try",
                loadComponent: () => import('./bookings-form/bookings-form.component').then(m => m.BookingsFormComponent)
            },


            {
                path: "schedule",
                loadComponent: () => import('./create-schedule/create-schedule.component').then(m => m.CreateScheduleComponent)
            },
            {
                path: "add-medicine",
                loadComponent: () => import('./medication2/add-medication/add-medication.component').then(m => m.AddMedicationComponent)
            },
            {
                path: "ec-bills",
                loadComponent: () => import('./encounter-v2/encounter-v2.component').then(m => m.EncounterV2Component)

            }, {
                path: "lab-report",
                loadComponent: () => import('./labreport/labreport.component').then(m => m.LabreportComponent)

            },
            {
                path: "add-report",
                loadComponent: () => import('./labreport/add-report/add-report.component').then(m => m.AddReportComponent)

            },
            {
                path: "medicine",
                loadComponent: () => import('./medication2/medication2.component').then(m => m.MedicationComponent2),

            },
            {
                path: "admission",
                loadComponent: () => import('./admission/admission.component').then(m => m.AdmissionComponent),
                // resolve: { admission: admissionResolver }
            },
            {
                path: "admission-analytics",
                loadComponent: () => import('./admission-analytics/admission-analytics.component').then(m => m.AdmissionAnalyticsComponent),

            },
            {
                path: "vitals",
                loadComponent: () => import('./patient-observation/add-vitals/add-vitals.component').then(m => m.AddVitalsComponent),
            },
            {
                path: "tasks",
                loadComponent: () => import('./testing-tasks/testing-tasks.component').then(m => m.TestingTasksComponent),


            },
            {

                path: "patientSide",
                loadComponent: () => import('./patient-sidedetails/patient-sidedetails.component').then(m => m.PatientSidedetailsComponent)
            },
            {
                path: "allergy",
                loadComponent: () => import('./allergy/allergy.component').then(m => m.AllergyComponent),
            },
            {
                path: "task-list",
                loadComponent: () => import('./tasks/tasks-table/tasks-table.component').then(m => m.TasksTableComponent),

            },
            {
                path: "tests-requests",
                loadComponent: () => import('./lab-requests/lab-requests.component').then(m => m.LabRequestsComponent),
                resolve: { labRequests: labRequestsResolver }


            },
            {
                path: "claims",
                loadComponent: () => import('./orders/orders.component').then(m => m.OrdersComponent),


            },
            {
                path: "invoice",
                loadComponent: () => import('./invoice/invoice.component').then(m => m.InvoiceComponent),
                data: { title: 'Invoice' }
            },
            {
                path: "medicine-requests",
                loadComponent: () => import('./medicine-requests/medicine-requests.component').then(m => m.MedicineRequestsComponent),
                // resolve: { medReqRes: medReqResResolver }


            },
            {
                path: "specimen-details",
                loadComponent: () => import('./specimen/specimen-details/specimen-details.component').then(m => m.SpecimenDetailsComponent),
                data: {
                    title: "Specimen Details", breadCrumbTitle: "Specimen Details",
                    breadCrumbIcon: "biotech"
                },
            },
            {
                path: "org",
                loadComponent: () => import('./hospital-details/hospital-details.component').then(m => m.HospitalDetailsComponent),
                data: {
                    title: "Hospital Details", breadCrumbTitle: "Hospital Details",
                    breadCrumbIcon: "local_hospital"
                },
            },

            //services,
            {
                path: "org-services",
                loadComponent: () => import('./services/services.component').then(m => m.ServicesComponent),
                data: {
                    title: "Available Services", breadCrumbTitle: "Available Services",
                    breadCrumbIcon: "work"
                }
            },
            {
                path: 'fulfill-task',
                loadComponent: () => import('./tasks/fulfill-task/fulfill-task.component').then(m => m.FulfillTaskComponent),
                // loadComponent: () => import('./tasks/fulfill-task/fulfill-task.component').then(m => m.FulfillTaskComponent),
                data: {
                    title: 'Test Fulfill Task',
                    breadCrumbTitle: 'Fulfill Task Test',
                    breadCrumbIcon: 'task_alt'
                }
            },
            {
                path: 'add-medication',
                loadComponent: () => import('./medication2/add-medication/add-medication.component').then(m => m.AddMedicationComponent),
                // loadComponent: () => import('./medication2/add-medication/add-medication.component').then(m => m.AddMedicationComponent),
                data: {
                    title: 'Test Add Medication',
                    breadCrumbTitle: 'Add Medication Test',
                    breadCrumbIcon: 'medication'
                }
            }
        ]
    },
    {
        path: "DummyMedicationRequest",
        loadComponent: () => import('./dummy-medication-request-details/dummy-medication-request-details.component').then(m => m.DummyMedicationRequestDetailsComponent),

    },

    {
        path: "login",
        loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
        data: { title: "Login" }
    },

    {
        path: "auth/callback",
        loadComponent: () => import('./authcallack/authcallack.component').then(m => m.AuthcallackComponent),
      data: { title: "Login Redirect" }
    },

    {
        path: "launch",
        loadComponent: () => import('./launch/launch.component').then(m => m.LaunchComponent),
        data: { title: "Launch" }
    },


    {
        path: "register",
        loadComponent: () => import('./patient-registration/patient-registration.component').then(m => m.PatientRegistrationComponent)
    },
    {
    path: 'documentation',
    loadChildren: () =>
        import('./documentation/documentation.routes').then(m => m.documentationRoutes),
    canActivate: [appAuthGuard],
    data: {
        title: 'Documentation',
        breadCrumbTitle: 'Documentation',
        breadCrumbIcon: 'menu_book'
    }
},
     {
    path: 'remote-doctor/register',
    loadComponent: () =>
        import('./remote-doctor/remote-doctor-registration/remote-doctor-registration.component')
            .then(m => m.RemoteDoctorRegistrationComponent),
    data: { title: 'Remote Doctor Registration' }
},
    {
        path: "upload-demo",
        loadComponent: () => import('./upload-ui/azure-upload-demo.component').then(m => m.AzureUploadDemoComponent)
    },

    { path: "zoom-meetings", redirectTo: "app/zoom-meetings", pathMatch: 'full' },
    { path: "zoom-meetings/:appointmentId", redirectTo: "app/zoom-meetings/:appointmentId", pathMatch: 'full' },
    { path: "", redirectTo: "launch", pathMatch: 'full' },
    { path: "**", component: NotFoundComponentComponent },
    //upload-demo
    // {
    //     path: 'app/service-requests',
    //     loadComponent: () =>
    //         import('./service-requests/service-requests.component').then(m => m.ServiceRequestsComponent),
    //     data: {
    //         title: 'Service Requests',
    //         breadCrumbTitle: 'Service Requests',
    //         breadCrumbIcon: 'assignment',
    //         roles: ['doctor', 'nurse', 'lab', 'pharmacy', 'consultant', 'hospitaladmin'] // view for practitioners; add button still doctor-only
    //     }
    // },
];
